import React from 'react';
// import LoadingSpinner from '../LoadingSpinner/LoadingSpinner';
import WatchListMovie from './WatchListMovie';
import './WatchList.scss';

const WatchList = () => {

    return (
        <div className='watchlist'>
            {/* <LoadingSpinner /> */}
            <section className="featured-section">
                <div className="featured-header">
                    <div className="featured-header-link">
                        Watchlist
                    </div>
                </div>
                <div className="watchlist-movies">
                    <WatchListMovie />
                </div>
            </section>
        </div>
    )
}

export default WatchList
